import React, { useEffect, useState } from "react";
import { apiGet } from "../../api/api_methods";
import logo from "../../assests/logo.png";
import {
  HiOutlineLocationMarker,
  HiOutlineMail,
  HiOutlineDeviceMobile,
} from "react-icons/hi";
import { BsPersonWorkspace } from "react-icons/bs";
import { MdOutlineScore } from "react-icons/md";
import PdfViewer from "../reusble_components/pdfViewer";
import { IoIosSearch } from "react-icons/io";
import ScoreCircle from "./Resume/ScoreCircle";
import { AiOutlineMail, AiOutlineMobile } from "react-icons/ai";

function extractScore(arr, type) {
  if (!Array.isArray(arr)) return "-";
  const arr2 = arr.reverse();
  const found = arr2.find((s) => s.name === type);
  return typeof found?.score === "number" ? found.score : 0;
}

const PAGE_SIZE = 12;

const defaultProfile =
  "https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png";

export default function InstantHireCandidates() {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [input, setInput] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    async function fetchCandidates() {
      setLoading(true);
      setError(null);
      try {
        const res = await apiGet(
          `/application/applicant-search?search=${encodeURIComponent(
            search
          )}&skip=${(page - 1) * PAGE_SIZE}&limit=${PAGE_SIZE}`
        );
        if (res.status === 200 && res.body.success) {
          setCandidates(res.body.data || []);
          setTotal(res.body.count || 0);
        } else {
          setError("Failed to fetch candidates");
        }
      } catch (e) {
        setError("Error fetching candidates");
      }
      setLoading(false);
    }
    fetchCandidates();
  }, [search, page]);

  const totalPages = Math.ceil(total / PAGE_SIZE);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setSearch(input.trim());
  };

  return (
    <div className="p-6 min-h-screen pt-10 bg-gray-50">
      {/* PDF Viewer Modal */}
      {pdfUrl && <PdfViewer pdfUrl={pdfUrl} onClose={() => setPdfUrl(null)} />}
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-2xl font-bold mb-6">Instant Hire</h2>
        <form
          onSubmit={handleSearch}
          className="mb-4 flex flex-col w-[40%] sm:w-[30%] px-2 sm:flex-row gap-2 justify-between bg-white rounded-full items-center"
        >
          <input
            type="text"
            placeholder="Search by Role or technology..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="rounded-full px-3 py-2 w-full sm:w-64 text-sm focus:outline-none  border-none"
          />
          <button
            type="submit"
            className=" text-primary px-4 py-2 rounded text-sm flex items-center gap-2"
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-t-2 border-b-2 border-primary rounded-full animate-spin"></div>
              </div>
            ) : (
              <IoIosSearch className="w-4 h-4 text-primary" />
            )}
          </button>
        </form>
      </div>

      {loading && <div className="text-center py-10">Loading...</div>}
      {error && <div className="text-center text-red-500 py-10">{error}</div>}
      {!loading && !error && candidates.length === 0 && (
        <div className="text-center text-gray-500 py-10">
          No candidates found.
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6 justify-items-center">
        {candidates.map((c) => {
          // Skills logic: show up to 3, then a +N chip
          let skills =
            c.skills && c.skills.length > 0
              ? c.skills
              : (c.resumeContent || "")
                  .split("\n")
                  .find((line) => line.toLowerCase().includes("skills"))
                  ?.replace(/skills[:\s]*/i, "")
                  .split(/,|\s+/)
                  .filter((s) => s && s.length < 20) || [];
          skills = skills.filter(Boolean);
          const shownSkills = skills.slice(0, 3);
          const extraSkills = skills.length > 3 ? skills.length - 3 : 0;

          return (
            <div
              key={c._id}
              className="flex flex-col w-full bg-white rounded-2xl shadow-sm p-5 transition-shadow hover:shadow-md"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              {/* Header: Logo, Name, Job Title */}
              <div className="flex items-center gap-3">
                <img
                  src={c?.pic || defaultProfile}
                  alt="logo"
                  className="w-14 h-14 rounded-full bg-gray-100 object-contain"
                />
                <div className="flex-1 min-w-0">
                  <div
                    className="text-base font-semibold text-gray-900 truncate"
                    title={c.name}
                  >
                    {c.name || "-"}
                  </div>
                  <div
                    className="text-xs text-gray-500 truncate"
                    title={c.jobTitle}
                  >
                    {c.jobTitle || "-"}
                  </div>
                </div>
                {/* ScoreCircle beside name/job title */}
                <div className="flex items-center justify-center w-14 h-14">
                <div className="relative w-24 h-24 mx-auto">
                  <svg
                    className="absolute top-0 left-0 w-full h-full"
                    viewBox="0 0 100 100"
                  >
                    <circle
                      cx="50"
                      cy="50"
                      r="45"
                      className="stroke-current text-gray-200"
                      strokeWidth="10"
                      fill="none"
                    />
                    <circle
                      cx="50"
                      cy="50"
                      r="45"
                      className="stroke-current text-primary"
                      strokeWidth="10"
                      fill="none"
                      strokeDasharray="282.6"
                      strokeDashoffset={
                        extractScore(c.overallScore, "total") === "Pending"
                          ? 282.6 // If overallScore is "Pending", treat as 0% (full circle)
                          : 282.6 -
                            (282.6 *
                              (extractScore(c.overallScore, "total"))) /
                              100
                      }
                      strokeLinecap="round"
                      transform="rotate(-90, 50, 50)"
                    />
                  </svg>
                  <div className="absolute inset-0 flex items-center justify-center text-primary">
                    <span
                      className={` font-semibold ${
                        extractScore(c.overallScore, "total") === "Pending"
                          ? "text-xs"
                          : "text-xs"
                      }`}
                    >
                      { extractScore(c.overallScore, "total") + "%"}
                    </span>
                  </div>
                </div>
                </div>
              </div>
              {/* Info Chips */}
              {/* <div className="flex flex-wrap gap-2 mb-3">
                <span className="flex items-center gap-1 text-xs text-gray-500 bg-gray-100 rounded px-2 py-0.5">
                  <HiOutlineLocationMarker className="w-4 h-4" />
                  {c.cityPreference && c.cityPreference.length > 0 ? c.cityPreference[0] : "Remote"}
                </span>
                <span className="flex items-center gap-1 text-xs text-gray-500 bg-gray-100 rounded px-2 py-0.5">
                  <BsPersonWorkspace className="w-4 h-4" />
                  {c.jobTitle || "Job"}
                </span>
                <span className="flex items-center gap-1 text-xs text-gray-500 bg-gray-100 rounded px-2 py-0.5">
                  <MdOutlineScore className="w-4 h-4" />
                  Score: {extractScore(c.overallScore, "total")}
                </span>
              </div> */}
              {/* Skills */}
              <div className="flex flex-row flex-wrap gap-x-2 gap-y-1 min-h-[32px] items-center">
                {shownSkills.length > 0 ? (
                  <>
                    {shownSkills.map((skill, i) => (
                      <span
                        key={i}
                        className="bg-gray-100 py-0.5 px-2 rounded-full text-xs font-medium truncate max-w-[100px] text-gray-500"
                      >
                        {skill}
                      </span>
                    ))}
                    {extraSkills > 0 && (
                      <span className="bg-gray-100 py-0.5 px-2 rounded-full text-xs font-medium text-gray-500">
                        +{extraSkills}
                      </span>
                    )}
                  </>
                ) : (
                  <span className="text-gray-300 text-xs">No skills</span>
                )}
              </div>
              {/* Contact Info */}
              <div className="flex flex-row gap-3 text-xs text-gray-600">
                <div className="flex items-center gap-1">
                  <AiOutlineMobile className="w-4 h-4 text-gray-400" />
                  <span className="truncate">{c.mobile || "-"}</span>
                </div>
                <div className="flex items-center gap-1">
                  <AiOutlineMail className="w-4 h-4 text-gray-400" />
                  <span className="truncate" title={c.email}>
                    {c.email || "-"}
                  </span>
                </div>
              </div>
              {/* Scores */}
              {/* (Removed simple score text, now shown as circle above) */}
              {/* Resume Link */}
              <div className="mt-auto">
                {c.resume ? (
                  <button
                    type="button"
                    onClick={() => setPdfUrl(c.resume)}
                    className="text-primary underline text-xs hover:text-primary/80 focus:outline-none"
                  >
                    View Resume
                  </button>
                ) : (
                  <span className="text-gray-400 text-xs">No Resume</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-2 mt-8">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
            className="px-3 py-1 rounded border text-sm disabled:opacity-50"
          >
            Prev
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              onClick={() => setPage(p)}
              className={`px-3 py-1 rounded border text-sm ${
                p === page
                  ? "bg-primary text-white border-primary"
                  : "bg-white border-gray-300"
              }`}
            >
              {p}
            </button>
          ))}
          <button
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className="px-3 py-1 rounded border text-sm disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
